import React, { memo, useCallback } from 'react';

const StatusStep = memo(({ 
  status, 
  index, 
  currentStatusIndex, 
  updatingStatus, 
  onStatusClick,
  getStatusClass 
}) => {
  const handleClick = useCallback(() => {
    // Allow clicking any status, not just future ones
    onStatusClick(status, index);
  }, [index, onStatusClick, status]);

  const isClickable = index !== currentStatusIndex; // All steps except current are clickable
  const statusClass = getStatusClass(index);

  return (
    <div
      className={`status-step ${statusClass} ${isClickable ? 'clickable' : ''}`}
      onClick={isClickable ? handleClick : undefined}
      title={isClickable ? `Go to ${status}` : `Current: ${status}`}
    >
      <div className="status-dot">
        {index < currentStatusIndex && <span className="checkmark">✓</span>}
        {index === currentStatusIndex && updatingStatus && <span className="spinner">⟳</span>}
      </div>
      <div className="status-label">{status}</div>
      {index < 11 && ( // modelingStatuses.length - 1
        <div className={`status-line ${index < currentStatusIndex ? 'completed' : ''}`} />
      )}
    </div>
  );
});

StatusStep.displayName = 'StatusStep';

export default StatusStep;